import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import leftDecrementArrow from "./../../../../assets/images/poc/leftDecrementArrow.svg";
import rightIncrementArrow from "./../../../../assets/images/poc/rightIncrementArrow.svg";
import "./CalendarChanger.scss";
import moment from "moment-timezone";

const CalendarChanger = ({
  activeTab,
  onMonthChange,
  onQuarterChange,
  onYearChange,
}) => {
  const currentYear = moment().year();
  const currentMonthIndex = moment().month();
  const currentQuarterIndex = Math.floor(moment().month() / 3);

  const [selectedMonthIndex, setSelectedMonthIndex] =
    useState(currentMonthIndex);
  const [selectedQuarterIndex, setSelectedQuarterIndex] =
    useState(currentQuarterIndex);
  const [currentYearIndex, setCurrentYearIndex] = useState(currentYear - 2023);

  const [years, setYears] = useState([]);

  useEffect(() => {
    const currentYear = moment().year();
    const startYear = 2023; // Adjust as per your requirement
    const futureYears = [];
    for (let year = startYear; year <= currentYear; year++) {
      futureYears.push(year);
    }
    console.log("");
    setYears(futureYears.reverse()); // Reverse the array before setting it
    if (activeTab === 0) {
      setSelectedMonthIndex(currentMonthIndex);
    } else if (activeTab === 1) {
      setSelectedQuarterIndex(currentQuarterIndex);
    } else if (activeTab === 2) {
      setCurrentYearIndex(futureYears.length - 1 - (currentYear - startYear)); // Adjust the calculation here
    }
  }, [activeTab]);

  const [currentMonths, setCurrentMonths] = useState([]);
  const [currentQuarters, setCurrentQuarters] = useState([]);

  useEffect(() => {
    setCurrentMonths(generateMonths(years));
    setCurrentQuarters(generateQuarters(years));
  }, [years]);

  const incrementMonth = () =>
    setSelectedMonthIndex(
      (prevIndex) => (prevIndex + 1) % currentMonths.length
    );
  const decrementMonth = () =>
    setSelectedMonthIndex(
      (prevIndex) =>
        (prevIndex - 1 + currentMonths.length) % currentMonths.length
    );

  const incrementQuarter = () =>
    setSelectedQuarterIndex(
      (prevIndex) => (prevIndex + 1) % currentQuarters.length
    );
  const decrementQuarter = () =>
    setSelectedQuarterIndex(
      (prevIndex) =>
        (prevIndex - 1 + currentQuarters.length) % currentQuarters.length
    );
  const incrementYear = () =>
    setCurrentYearIndex((prevIndex) => (prevIndex + 1) % years.length);
  const decrementYear = () =>
    setCurrentYearIndex(
      (prevIndex) => (prevIndex - 1 + years.length) % years.length
    );
  useEffect(() => {
    if (activeTab === 0) {
      const selectedMonth = currentMonths[selectedMonthIndex];
      const startDate = moment(selectedMonth, "MMM YYYY")
        .startOf("month")
        .format("YYYY-MM-DD");
      const endDate = moment(selectedMonth, "MMM YYYY")
        .endOf("month")
        .format("YYYY-MM-DD");
      onMonthChange(startDate, endDate);
    } else if (activeTab === 1) {
      const selectedQuarter = currentQuarters[selectedQuarterIndex];
      const year = parseInt(selectedQuarter.split(" ")[1]);
      const quarterIndex =
        parseInt(selectedQuarter.split(" ")[0].substring(1)) - 1;
      let quarterStartDate, quarterEndDate;
      if (quarterIndex === 0) {
        quarterStartDate = `${year}-01-01`;
        quarterEndDate = `${year}-03-31`;
      } else if (quarterIndex === 1) {
        quarterStartDate = `${year}-04-01`;
        quarterEndDate = `${year}-06-30`;
      } else if (quarterIndex === 2) {
        quarterStartDate = `${year}-07-01`;
        quarterEndDate = `${year}-09-30`;
      } else if (quarterIndex === 3) {
        quarterStartDate = `${year}-10-01`;
        quarterEndDate = `${year}-12-31`;
      }
      onQuarterChange(quarterStartDate, quarterEndDate);
    } else if (activeTab === 2) {
      const year = years[currentYearIndex];
      const yearStartDate = moment(year.toString(), "YYYY")
        .startOf("year")
        .format("YYYY-MM-DD");
      const yearEndDate = moment(year.toString(), "YYYY")
        .endOf("year")
        .format("YYYY-MM-DD");
      onYearChange(yearStartDate, yearEndDate);
    }
  }, [selectedMonthIndex, selectedQuarterIndex, currentYearIndex]);

  const handleLeftArrowClick = () => {
    if (activeTab === 0) {
      decrementMonth();
    } else if (activeTab === 1) {
      decrementQuarter();
    } else if (activeTab === 2) {
      decrementYear();
    }
  };

  const handleRightArrowClick = () => {
    if (activeTab === 0) {
      incrementMonth();
    } else if (activeTab === 1) {
      incrementQuarter();
    } else if (activeTab === 2) {
      incrementYear();
    }
  };

  return (
    <>
      <div className="calenderChangeButton">
        <div className="arrowLeftContainer" onClick={handleLeftArrowClick}>
          <img src={leftDecrementArrow} alt="Left Arrow" />
        </div>
        <div className="calendarValueContainer">
          {activeTab === 0 && currentMonths[selectedMonthIndex]}
          {activeTab === 1 && currentQuarters[selectedQuarterIndex]}
          {activeTab === 2 && years[currentYearIndex]}
        </div>
        <div className="arrowRightContainer" onClick={handleRightArrowClick}>
          <img src={rightIncrementArrow} alt="Right Arrow" />
        </div>
      </div>
    </>
  );
};

const generateMonths = (years) => {
  let months = [];
  for (let year of years) {
    for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
      months.push(`${moment().month(monthIndex).format("MMM")} ${year}`);
    }
  }
  return months;
};

const generateQuarters = (years) => {
  let quarters = [];
  for (let year of years) {
    for (let quarterIndex = 1; quarterIndex <= 4; quarterIndex++) {
      quarters.push(`Q${quarterIndex} ${year}`);
    }
  }
  return quarters;
};

CalendarChanger.propTypes = {
  activeTab: PropTypes.number.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onQuarterChange: PropTypes.func.isRequired,
  onYearChange: PropTypes.func.isRequired,
};

export default CalendarChanger;
